import * as React from 'react';

import { COLOR_BASE_BRAND_WHITE } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { InfoI, useServicesContext } from '@oneaudi/vtp-shared';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackLayerOpen } from '../tracking/tracking';

interface HighlightInfoProps {
  infoLink: string;
}

const InfoIWrap = styled.span`
  display: inline-block;
  height: 24px;
  vertical-align: top;
`;

const InfoILink = styled.a`
  color: ${COLOR_BASE_BRAND_WHITE};
  display: inline-block;
  height: 24px;
  margin-left: var(${(props): string => props.theme.responsive.spacing.xs});
  width: 24px;
`;

const HighlightInfo: React.FC<HighlightInfoProps> = ({ infoLink }) => {
  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service',
  ) as TrackingServiceV2;
  return (
    <InfoIWrap>
      <InfoILink
        className="nm-layerLink"
        href={infoLink}
        x-cq-linkchecker="skip"
        onClick={() => trackLayerOpen(trackingService, infoLink)}
      >
        <InfoI />
      </InfoILink>
    </InfoIWrap>
  );
};

export default HighlightInfo;
